import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'store';
import PrivateSpaceCard from './PrivateSpaceCard';

var PrivateSpace = function PrivateSpace() {
  var privateSpace = useSelector(function (state) {
    return state.service.privateSpace;
  });
  var sortPrivateSpace = privateSpace.slice(0, privateSpace.length).sort(function (prev, next) {
    return prev.id - next.id;
  });
  return /*#__PURE__*/_jsx("div", {
    className: "soption-li",
    children: /*#__PURE__*/_jsx("ul", {
      children: sortPrivateSpace.map(function (space, index) {
        if (index === 0) {
          return /*#__PURE__*/_jsx(PrivateSpaceCard, {
            space: space
          }, space.id);
        }

        return /*#__PURE__*/_jsx("div", {
          style: {
            marginTop: '70px'
          },
          children: /*#__PURE__*/_jsx(PrivateSpaceCard, {
            space: space
          })
        }, space.id);
      })
    })
  });
};

export default PrivateSpace;